import React from 'react';
import classNames from 'classnames';
import useStyles from './useStyles';

export type Props = React.PropsWithChildren<
  {
    size?: 'sm' | 'md' | 'lg';
  } & React.ButtonHTMLAttributes<HTMLButtonElement>
>;
function SurveyButton({
  size = 'md',
  className,
  type = 'button',
  children,
  ...buttonProps
}: Props): React.ReactElement {
  const { surveyButton } = useStyles({ size });
  return (
    // eslint-disable-next-line react/button-has-type
    <button type={type} className={classNames(surveyButton, className)} {...buttonProps}>
      {children}
    </button>
  );
}

export default SurveyButton;
